import * as React from 'react';
import PropTypes from 'prop-types';

const SvgAchievementsLocalLegendNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#achievements_local_legend_normal_xsmall_svg__clip0_138_779)">
        <path
          d="M11.275 1.946a2.7 2.7 0 01.535 1.393 5.9 5.9 0 011.335 1.494v-.077a3.409 3.409 0 011.11-2 3.58 3.58 0 01.78 2.24 3.412 3.412 0 01-1.079 1.972c.048.28.075.562.082.846a2.702 2.702 0 011.957-.758 3.71 3.71 0 01-.64 2.29 2.7 2.7 0 01-1.657.797 5.57 5.57 0 01-.547 1.105c.05-.017.102-.033.153-.048l.05-.014a2.88 2.88 0 012.07.92 3.09 3.09 0 01-1.85 1.39 2.88 2.88 0 01-1.87-.725 5.581 5.581 0 01-1.46.749l-.019.006-.028.008a5.361 5.361 0 00-1.912.86l-.02-.027a.5.5 0 01-.536.003l-.02.027a5.68 5.68 0 00-1.948-.864 5.586 5.586 0 01-1.489-.752 2.898 2.898 0 01-1.857.715 3.09 3.09 0 01-1.86-1.39 2.902 2.902 0 012.07-.92l.113.032.067.022a5.59 5.59 0 01-.543-1.1 2.688 2.688 0 01-1.627-.794 3.67 3.67 0 01-.63-2.29 2.73 2.73 0 011.92.724c.01-.292.043-.583.096-.87a3.419 3.419 0 01-1.016-1.974 3.57 3.57 0 01.79-2.18A3.38 3.38 0 012.894 4.75a5.901 5.901 0 011.27-1.386l.01-.007a2.697 2.697 0 01.53-1.41 2.461 2.461 0 012-.3 3.06 3.06 0 01-.7 1.94A2.17 2.17 0 014.912 4a.497.497 0 01-.126.148 4.899 4.899 0 00-1.183 1.355l.073-.058a2.391 2.391 0 011.93 0 3.11 3.11 0 01-1.14 1.78 2.389 2.389 0 01-1.503.143 4.886 4.886 0 00-.037.763v.018a4.591 4.591 0 001.158 3.086 3.403 3.403 0 01-.088-.9 3.17 3.17 0 011.13-1.89 3.4 3.4 0 01.66 2.15 3.13 3.13 0 01-.702 1.485c.29.181.603.33.93.444a6.68 6.68 0 012.01.841 6.36 6.36 0 011.924-.8 4.69 4.69 0 00.972-.47 3.172 3.172 0 01-.724-1.5 3.43 3.43 0 01.67-2.15 3.13 3.13 0 011.12 1.89c.011.313-.02.624-.092.925a4.582 4.582 0 001.142-3.07v-.026c.012-.27 0-.539-.032-.805a2.39 2.39 0 01-1.538-.134 3.11 3.11 0 01-1.14-1.78 2.39 2.39 0 011.93 0c.06.047.12.097.178.148a4.9 4.9 0 00-1.213-1.449.497.497 0 01-.12-.142 2.175 2.175 0 01-1.115-.417 3.06 3.06 0 01-.7-1.94 2.43 2.43 0 011.99.3z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="achievements_local_legend_normal_xsmall_svg__clip0_138_779">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgAchievementsLocalLegendNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgAchievementsLocalLegendNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgAchievementsLocalLegendNormalXsmall;
